import type { Role } from './types';

export const SCHOOL = {
  name: 'Baseras School',
  tagline: 'Where Curiosity Meets Excellence',
  established: 1985,
  address: '12 MG Road, Pune, Maharashtra 411001',
  phone: '+91 20 2612 3456',
  email: 'info@baserasschool.edu.in',
};

export const ROLES: Role[] = ['STUDENT', 'TEACHER', 'ADMIN', 'PRINCIPAL'];

export const ROLE_LABELS: Record<Role, string> = {
  STUDENT: 'Student',
  TEACHER: 'Teacher',
  ADMIN: 'Administrator',
  PRINCIPAL: 'Principal',
};

export const ROLE_COLORS: Record<Role, string> = {
  STUDENT: '#0EA5E9',
  TEACHER: '#10B981',
  ADMIN: '#F59E0B',
  PRINCIPAL: '#1E3A8A',
};

export const DAYS_OF_WEEK = [
  { value: 1, label: 'Monday', short: 'Mon' },
  { value: 2, label: 'Tuesday', short: 'Tue' },
  { value: 3, label: 'Wednesday', short: 'Wed' },
  { value: 4, label: 'Thursday', short: 'Thu' },
  { value: 5, label: 'Friday', short: 'Fri' },
  { value: 6, label: 'Saturday', short: 'Sat' },
];

export const PERIODS = [
  { value: 1, label: 'Period 1', startTime: '08:00', endTime: '08:45' },
  { value: 2, label: 'Period 2', startTime: '08:45', endTime: '09:30' },
  { value: 3, label: 'Period 3', startTime: '09:30', endTime: '10:15' },
  { value: 4, label: 'Period 4', startTime: '10:30', endTime: '11:15' },
  { value: 5, label: 'Period 5', startTime: '11:15', endTime: '12:00' },
  { value: 6, label: 'Period 6', startTime: '12:00', endTime: '12:45' },
  { value: 7, label: 'Period 7', startTime: '13:30', endTime: '14:15' },
  { value: 8, label: 'Period 8', startTime: '14:15', endTime: '15:00' },
];
